import localStorage from '../browser/local-storage'
import sessionStorage from '../browser/session-storage'
//import storage from '../browser/storage'
import mixpanel from './mixpanel'
import {MixPanelDebug} from '../config'
import {canUseDOM} from '../app/exec-env'

// the code below only happen once when the react app is loaded
if (canUseDOM) {
  const now = new Date().getTime()
  const pst = now - (1000*60*60*8) // UTC-8 reporting
  const day = pst - pst % (1000*60*60*24) // round to reporting day
  //const page = window.location.pathname

  if (MixPanelDebug) mixpanel.set_debug(true)
  mixpanel.init() // don't wait for init to callback as we may disable mixpanel in dev

  // count new visits and return visits
  if (localStorage.enabled) {
    const firstVisit = localStorage.setIntOnce(`firstVisit`, now)
    const lastVisit = localStorage.setInt(`lastVisit`, day)
    const distinct_id = localStorage.getItem(`distinct_id`)
    if (distinct_id != null) mixpanel.identify(distinct_id)
    mixpanel.register_once(`firstVisit`, new Date(now).toISOString())
    if (firstVisit == null) mixpanel.track(`new visits`)
    else if (lastVisit !== day) {
      if (distinct_id != null) mixpanel.track(`returning players`)
      else mixpanel.track(`returning guests`)
    }
  }
  else {
    mixpanel.track(`incognito visits`)
  }

  // count sessions
  const sessionVisit = sessionStorage.setInt(`sessionVisit`, now)
  // no existing session or last app load occured more than 1 hour ago
  if (sessionVisit == null || now - sessionVisit > 1000*60*60) mixpanel.track(`sessions`)
}

export const getFirstVisit = () => {
  return localStorage.getDate(`firstVisit`)
}



// WEBPACK FOOTER //
// ./src/analytics/identify.js